import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Modal,
  Select,
  Spin
} from 'antd';
import { ContentWrapper, StyldDivider, StyledAlert } from '../styled';
import {
  ButtonContainer,
  FormItemWith30,
  FormItemWith40,
  FormItemWith50,
  InlineContainer,
  LabelContainer,
  StyldAnchor,
  StyledLabel,
  WeightageInput
} from './styled';
import InfoIcon from './InfoIcon';
import img_ns_house from '../../../../assets/img_ns_house.png';
import img_ns_map from '../../../../assets/img_ns_map.png';
import img_ns_search from '../../../../assets/img_ns_search.png';
import img_ns_segment from '../../../../assets/img_ns_segment.png';
import { isEmpty, keys, round, uniqueId } from 'lodash';
import {
  DDMMYYYYFormat,
  YYYYMMDDFormat
} from '../../../../util/GlobalConstant';
import {
  nameRules,
  partyKeyRules,
  aliasRules,
  countryRules,
  nationalityRules,
  cityRules,
  zipRules,
  addressRules,
  customerIdNoRules,
  merchantRegistrationNumberRules
} from '../Utils';
import {
  resetSingleScreening,
  fetchSegmentsList,
  proceedScreening
} from '../../../../redux/actions/ns/onDemandScreening';
import moment from 'moment';
import SideDrawer from '../SideDrawer';
import { ROUTE_AMLS_SMART_SCREENING } from '../../../constants/globalConstants';
import { InfoCircleOutlined } from '@ant-design/icons';

const { confirm, warning } = Modal;

const INDIVIDUAL_CORPORATE_TYPE = [
  {
    value: 'I',
    label: 'Individual'
  },
  {
    value: 'C',
    label: 'Corporate'
  }
];

const GENDER_OPTIONS = [
  {
    value: 'Male',
    label: 'Male'
  },
  {
    value: 'Female',
    label: 'Female'
  }
];
const PLACEHOLDER_SELECT = 'Please select';

const SingleNameScreening = ({
  dispatch,
  history,
  isLoading,
  hasScreeningError,
  hasError,
  errorMessage,
  segments,
  alertId,
  isSingleScreeningSuccess,
  bulkScreeningStarted
}) => {
  const [form] = Form.useForm();
  const [customerType, setCustomerType] = useState('I');
  const [collapsed, setCollapsed] = useState(true);
  const [disableReset, setDisableReset] = useState(true);
  const [disableSave, setDisableSave] = useState(true);
  const [selectedSegment, setSelectedSegment] = useState({});
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);
  const [currentDrawerItem, setCurrentDrawerItem] = useState('');

  useEffect(() => {
    if (isEmpty(segments)) {
      dispatch(fetchSegmentsList());
    }
  }, []);

  useEffect(() => {
    if (isSingleScreeningSuccess) {
      if (alertId) {
        history.push(`${ROUTE_AMLS_SMART_SCREENING}/alert/${alertId}/1`);
        dispatch(resetSingleScreening());
      } else {
        warning({
          title: 'Search Result',
          content: 'No hit above threshold, so no alert generated',
          onOk: () => {
            dispatch(resetSingleScreening());
          }
        });
      }
    }
  }, [isSingleScreeningSuccess, alertId]);

  useEffect(() => {
    if (hasError || hasScreeningError)
      window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [hasError, hasScreeningError]);

  const segmentOptions = useMemo(() => {
    const options = [];

    segments?.forEach((segment) => {
      if (!segment.customerTypeSegment) {
        setSelectedSegment(segment);
      } else {
        options.push({
          value: segment.customerTypeSegment,
          label: segment.customerTypeSegment
        });
      }
    });

    return options;
  }, [segments]);

  const getWeightagePercentage = useCallback((weightages) => {
    const weightagePercentage = {};
    weightages.forEach(({ name, value }) => {
      const objectName = name?.toLowerCase()?.replaceAll(' ', '_');
      weightagePercentage[objectName] = `${round(value * 100, 2)} %`;
    });

    return weightagePercentage;
  });

  const setWeightageValues = () => {
    const {
      address,
      alias,
      country_of_birth,
      date,
      gender,
      name,
      nationality,
      identification_number
    } = getWeightagePercentage(selectedSegment?.weightage || []);

    form.setFieldsValue({
      nameWeightage: name,
      aliasWeightage: alias,
      genderWeightage: gender,
      dateOfBirthWeightage: date,
      countryOfBirthWeightage: country_of_birth,
      nationalityWeightage: nationality,
      identificationNumberWeightage: identification_number,
      addressWeightage: address
    });
  };

  useEffect(() => {
    setWeightageValues();
  }, [selectedSegment]);

  const onClickAddMore = () => {
    setCollapsed(false);
  };

  const onClickReset = () => {
    confirm({
      className: 'on-demand-screening-button-css',
      title: 'Do you want to proceed to reset?',
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => {
        form.resetFields();
        setDisableReset(true);
        setDisableSave(true);
        setSelectedSegment(
          segments.find(({ customerTypeSegment }) => !customerTypeSegment)
        );
        setWeightageValues();
      }
    });
  };

  const onValuesChange = (values) => {
    if (keys(values).includes('party_name')) {
      setDisableSave(!values.party_name);
    }

    if (keys(values).includes('party_segment')) {
      setSelectedSegment(
        segments.find(
          ({ customerTypeSegment }) =>
            values.party_segment === customerTypeSegment
        )
      );
    }
    if (keys(values).includes('individual_corporate_type')) {
      setCustomerType(values.individual_corporate_type);
    }

    if (keys(values).includes('individual_corporate_type')) {
      setCustomerType(values.individual_corporate_type);
    }

    if (keys(values).includes('individual_corporate_type')) {
      setCustomerType(values.individual_corporate_type);
    }

    if (disableReset) {
      setDisableReset(false);
    }
  };

  const onFinish = (values) => {
    const {
      party_name,
      individual_corporate_type,
      party_segment,
      party_key,
      customer_aliases,
      gender,
      dateOfBirth,
      birth_incorporation_country,
      nationality,
      party_id_no,
      registered_number,
      city,
      postCode,
      addressLine1,
      addressLine2
    } = values;
    const screeningData = {
      party_key: party_key || `${uniqueId(moment().valueOf())}`,
      party_name,
      individual_corporate_type:
        individual_corporate_type || INDIVIDUAL_CORPORATE_TYPE[0].value,
      party_segment,
      customer_aliases,
      gender,
      birth_incorporation_country,
      citizenship_country: nationality,
      party_id_no,
      registered_number
    };
    const address = `${addressLine1 || ''} ${addressLine2 || ''} ${
      city || ''
    } ${postCode || ''}`;

    if (address.trim() !== '') {
      screeningData['residential_address'] = address
        .replace(/\s{2,}/g, ' ')
        .trim();
    }

    if (dateOfBirth) {
      screeningData['date_of_birth_or_incorporation'] =
        moment(dateOfBirth).format(YYYYMMDDFormat);
    }

    dispatch(
      proceedScreening({
        screeningData: JSON.stringify([{ ...screeningData }])
      })
    );
  };

  const onClickLabel = (clickedItem) => {
    setCurrentDrawerItem(clickedItem);
    setIsOpenDrawer(true);
  };

  const onCloseDrawer = () => {
    setIsOpenDrawer(false);
    setCurrentDrawerItem('');
  };

  const disabledDate = (current) => {
    // Disable dates after the new "to" date
    return current && current > moment();
  };

  const isHardRuleEnabled =
    selectedSegment?.weightage?.filter(
      (obj) => obj.name === 'Identification Number'
    )[0]?.hardRule == true || false;

  return bulkScreeningStarted ? (
    <div>Not permitted</div>
  ) : (
    <ContentWrapper>
      {(hasError || hasScreeningError) && (
        <StyledAlert type="error" message={errorMessage} />
      )}
      <Spin spinning={isLoading}>
        <Form
          form={form}
          name="nameScreening"
          autoComplete="off"
          layout="vertical"
          onValuesChange={onValuesChange}
          onFinish={onFinish}
          initialValues={{
            individual_corporate_type: 'I'
          }}>
          <Row gutter={[16, 8]}>
            <Col span={4} />
            <Col span={4}>
              {collapsed ? (
                <InfoIcon title="Name and Segment" icon={img_ns_search} />
              ) : (
                <InfoIcon
                  title="Segment"
                  subTitle="watchlist and whitelist attached will change accordingly"
                  icon={img_ns_segment}
                />
              )}
            </Col>
            <Col span={10}>
              <InlineContainer>
                {collapsed && (
                  <>
                    <FormItemWith40
                      label="Party Name"
                      name="party_name"
                      rules={nameRules}>
                      <Input placeholder="Enter Name" maxLength={300} />
                    </FormItemWith40>
                    <FormItemWith30
                      label="Individual/Corporate Type"
                      name="individual_corporate_type">
                      <Select options={INDIVIDUAL_CORPORATE_TYPE} />
                    </FormItemWith30>
                  </>
                )}
                <FormItemWith30
                  label="Segment"
                  name="party_segment"
                  tooltip={{
                    title: `If the required segment is not available, in that case don't select anything from the dropdown. System will fall to the default configuration. To get the segment added, please get in touch with your admin.`,
                    icon: <InfoCircleOutlined />
                  }}>
                  <Select
                    allowClear
                    options={segmentOptions}
                    placeholder={PLACEHOLDER_SELECT}
                  />
                </FormItemWith30>
              </InlineContainer>
              {collapsed && (
                <>
                  <StyldAnchor target="_self" onClick={onClickAddMore}>
                    Add more details
                  </StyldAnchor>
                  <ButtonContainer className="on-demand-screening-button-css">
                    <Button disabled={disableReset} onClick={onClickReset}>
                      Reset
                    </Button>
                    <Button
                      type="primary"
                      disabled={disableSave || hasError}
                      htmlType="submit">
                      Proceed to screen
                    </Button>
                  </ButtonContainer>
                </>
              )}
            </Col>
            <Col span={6}>
              <LabelContainer>
                <StyledLabel onClick={() => onClickLabel('watchLists')}>
                  {selectedSegment?.watchLists?.length || 0} Watchlist
                </StyledLabel>
                <StyledLabel onClick={() => onClickLabel('whiteLists')}>
                  {selectedSegment?.whiteLists?.length || 0} Whitelist
                </StyledLabel>
              </LabelContainer>
              <SideDrawer
                isOpen={isOpenDrawer}
                visibleItem={currentDrawerItem}
                segment={selectedSegment}
                onClose={onCloseDrawer}
              />
            </Col>
          </Row>
          {!collapsed && (
            <>
              <StyldDivider />
              <Row gutter={[16, 8]}>
                <Col span={4} />
                <Col span={4}>
                  <InfoIcon title="Name and Aliases" icon={img_ns_search} />
                </Col>
                <Col span={10}>
                  <InlineContainer>
                    <FormItemWith50
                      label="Party Name"
                      name="party_name"
                      rules={nameRules}>
                      <Input placeholder="Enter Name" maxLength={300} />
                    </FormItemWith50>
                    <Form.Item label="Weightage" name="nameWeightage">
                      <WeightageInput disabled />
                    </Form.Item>
                  </InlineContainer>
                  <FormItemWith50
                    label="Individual/Corporate Type"
                    name="individual_corporate_type">
                    <Select options={INDIVIDUAL_CORPORATE_TYPE} />
                  </FormItemWith50>
                  <FormItemWith50
                    label="Party ID"
                    name="party_key"
                    rules={partyKeyRules}>
                    <Input placeholder="Enter Party ID" maxLength={50} />
                  </FormItemWith50>
                  <InlineContainer>
                    <FormItemWith50
                      label="Party Alias"
                      name="customer_aliases"
                      rules={aliasRules}>
                      <Input placeholder="Enter Alias" maxLength={10000} />
                    </FormItemWith50>
                    <Form.Item label="Weightage" name="aliasWeightage">
                      <WeightageInput disabled />
                    </Form.Item>
                  </InlineContainer>
                  <InlineContainer>
                    <FormItemWith50 label="Gender" name="gender">
                      <Select
                        placeholder="Select Gender"
                        options={GENDER_OPTIONS}
                      />
                    </FormItemWith50>
                    <Form.Item label="Weightage" name="genderWeightage">
                      <WeightageInput disabled />
                    </Form.Item>
                  </InlineContainer>
                </Col>
                <Col span={6} />
              </Row>
              <StyldDivider />
              <Row gutter={[16, 8]}>
                <Col span={4} />
                <Col span={4}>
                  <InfoIcon
                    title="Date and Country of Birth/Incorporation"
                    icon={img_ns_map}
                  />
                </Col>
                <Col span={10}>
                  <InlineContainer>
                    <FormItemWith50 label="Date of Birth" name="dateOfBirth">
                      <DatePicker
                        format={DDMMYYYYFormat}
                        placeholder="Select Date"
                        disabledDate={disabledDate}
                      />
                    </FormItemWith50>
                    <Form.Item label="Weightage" name="dateOfBirthWeightage">
                      <WeightageInput disabled />
                    </Form.Item>
                  </InlineContainer>
                  <InlineContainer>
                    <FormItemWith50
                      label="Customer Country of Birth/Incorporation"
                      name="birth_incorporation_country"
                      rules={countryRules}>
                      <Input placeholder="Enter Country" maxLength={300} />
                    </FormItemWith50>
                    <Form.Item label="Weightage" name="countryOfBirthWeightage">
                      <WeightageInput disabled />
                    </Form.Item>
                  </InlineContainer>
                  <InlineContainer>
                    <FormItemWith50
                      label="Customer Nationality"
                      name="nationality"
                      rules={nationalityRules}>
                      <Input placeholder="Enter Nationality" maxLength={300} />
                    </FormItemWith50>
                    <Form.Item label="Weightage" name="nationalityWeightage">
                      <WeightageInput disabled />
                    </Form.Item>
                  </InlineContainer>
                  {customerType == 'I' ? (
                    <InlineContainer>
                      <FormItemWith50
                        label={'Customer Identification Number'}
                        name="party_id_no"
                        rules={customerIdNoRules}>
                        <Input
                          placeholder={'Enter Customer Identification Number'}
                          maxLength={300}
                        />
                      </FormItemWith50>
                      <Form.Item
                        label="Weightage"
                        name="identificationNumberWeightage">
                        <WeightageInput disabled />
                      </Form.Item>
                      {isHardRuleEnabled && (
                        <Form.Item style={{ display: 'flex' }}>
                          <Button
                            disabled={true}
                            style={{
                              backgroundColor: '#2c73e0',
                              color: '#fff'
                            }}>
                            Hard Rule
                          </Button>
                        </Form.Item>
                      )}
                    </InlineContainer>
                  ) : (
                    <InlineContainer>
                      <FormItemWith50
                        label={'Merchant Registration Number'}
                        name="registered_number"
                        rules={merchantRegistrationNumberRules}>
                        <Input
                          placeholder={'Enter Merchant Registration Number'}
                          maxLength={300}
                        />
                      </FormItemWith50>
                      <Form.Item
                        label="Weightage"
                        name="identificationNumberWeightage">
                        <WeightageInput disabled />
                      </Form.Item>
                      {isHardRuleEnabled && (
                        <Form.Item>
                          <Button
                            disabled={true}
                            style={{
                              backgroundColor: '#2c73e0',
                              color: '#fff'
                            }}>
                            Hard Rule
                          </Button>
                        </Form.Item>
                      )}
                    </InlineContainer>
                  )}
                </Col>
                <Col span={6} />
              </Row>
              <StyldDivider />
              <Row gutter={[16, 8]}>
                <Col span={4} />
                <Col span={4}>
                  <InfoIcon
                    title="Where they currently reside"
                    subTitle="this section is not weighted, but will still help narrow your search for better accuracy"
                    icon={img_ns_house}
                  />
                </Col>
                <Col span={10}>
                  <FormItemWith50 label="City" name="city" rules={cityRules}>
                    <Input placeholder="Enter City" maxLength={300} />
                  </FormItemWith50>
                  <FormItemWith50
                    label="Zip/Postal Code"
                    name="postCode"
                    rules={zipRules}>
                    <Input
                      placeholder="Enter Zip/Postal Code"
                      maxLength={300}
                    />
                  </FormItemWith50>
                  <FormItemWith50
                    label="Address Line 1"
                    name="addressLine1"
                    rules={addressRules}>
                    <Input placeholder="Enter Address Line 1" maxLength={300} />
                  </FormItemWith50>
                  <InlineContainer>
                    <FormItemWith50
                      label="Address Line 2"
                      name="addressLine2"
                      rules={addressRules}>
                      <Input
                        placeholder="Enter Addres Line 2"
                        maxLength={300}
                      />
                    </FormItemWith50>
                    <Form.Item label="Weightage" name="addressWeightage">
                      <WeightageInput disabled />
                    </Form.Item>
                  </InlineContainer>
                </Col>
                <Col span={6} />
              </Row>
              <StyldDivider />
              <Row gutter={[16, 8]}>
                <Col span={8} />
                <Col span={10}>
                  <ButtonContainer className="on-demand-screening-button-css">
                    <Button disabled={disableReset} onClick={onClickReset}>
                      Reset
                    </Button>
                    <Button
                      type="primary"
                      disabled={disableSave || hasError}
                      htmlType="submit">
                      Proceed to screen
                    </Button>
                  </ButtonContainer>
                </Col>
                <Col span={6} />
              </Row>
            </>
          )}
        </Form>
      </Spin>
    </ContentWrapper>
  );
};

SingleNameScreening.propTypes = {
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  hasScreeningError: PropTypes.bool,
  hasError: PropTypes.bool,
  errorMessage: PropTypes.string,
  segments: PropTypes.array,
  alertId: PropTypes.string,
  isSingleScreeningSuccess: PropTypes.bool,
  bulkScreeningStarted: PropTypes.bool
};

const mapStateToProps = (state) => {
  const {
    singleScreening: {
      isLoading,
      hasError,
      hasScreeningError,
      errorMessage,
      segments,
      alertId,
      isSingleScreeningSuccess
    },
    bulkScreening: { bulkScreeningStarted }
  } = state.nsOnDemandScreening;
  return {
    isLoading,
    hasError,
    hasScreeningError,
    errorMessage,
    segments,
    alertId,
    isSingleScreeningSuccess,
    bulkScreeningStarted
  };
};

export default connect(mapStateToProps)(SingleNameScreening);
